define('services/namedLoggingServiceFactory',[
    'lib/knockout',
    'services/namedLoggingService'
], function (
    ko,
    NamedLoggingService
) {
    'use strict';

    var NamedLoggingServiceFactory = function() {

        var self = this;

        self.createLoggingService = function (namespace){
            var loggingService = new NamedLoggingService(namespace);
            return loggingService;
        };

    };

    return new NamedLoggingServiceFactory();
});

